import React from 'react';
import ClientImgOne1 from "../../assets/images/resources/client-one-img-1.png";
import ClientImgOne2 from "../../assets/images/resources/client-one-img-2.png";
import ClientImgOne3 from "../../assets/images/resources/client-one-img-3.png";
import ClientImgOne4 from "../../assets/images/resources/client-one-img-4.png";
import ClientImgOne5 from "../../assets/images/resources/client-one-img-5.png";
import ClientImgOne6 from "../../assets/images/resources/client-one-img-6.png";
import ClientImgOne7 from "../../assets/images/resources/client-one-img-7.png";
import ClientImgOne8 from "../../assets/images/resources/client-one-img-8.png";

function PartnerThree() {
  return (
    <div>
      <section className="partener-three">
        <div className="container">
          <div className="partener-three-title-box">
            <div
              className="section-four-title text-center wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="100ms"
            >
              <div className="section-four-title-title ">
                <h2>
                  Explore Our Global{" "}
                  <span className="section-four-title-title-inner">
                    Clients
                  </span>
                </h2>
              </div>
            </div>
            <div className="partener-three-img-box">
              <div className="partener-three-img-box-line" />
              <div className="row align-items-center">
                <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">
                  <div
                    className="partener-three-img wow fadeInUp animated"
                    data-wow-duration="1500ms"
                    data-wow-delay="100ms"
                  >
                    <img
                      src={ClientImgOne1}
                      alt="client-one-img-1"
                    />
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">
                  <div
                    className="partener-three-img wow fadeInUp animated"
                    data-wow-duration="1500ms"
                    data-wow-delay="200ms"
                  >
                    <img
                      src={ClientImgOne2}
                      alt="client-one-img-2"
                    />
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">
                  <div
                    className="partener-three-img wow fadeInUp animated"
                    data-wow-duration="1500ms"
                    data-wow-delay="300ms"
                  >
                    <img
                      src={ClientImgOne3}
                      alt="client-one-img-3"
                    />
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">
                  <div
                    className="partener-three-img wow fadeInUp animated"
                    data-wow-duration="1500ms"
                    data-wow-delay="400ms"
                  >
                    <img
                      src={ClientImgOne4}
                      alt="client-one-img-4"
                    />
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">
                  <div
                    className="partener-three-img wow fadeInUp animated"
                    data-wow-duration="1500ms"
                    data-wow-delay="500ms"
                  >
                    <img
                      src={ClientImgOne5}
                      alt="client-one-img-5"
                    />
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">
                  <div
                    className="partener-three-img wow fadeInUp animated"
                    data-wow-duration="1500ms"
                    data-wow-delay="600ms"
                  >
                    <img
                      src={ClientImgOne6}
                      alt="client-one-img-6"
                    />
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">
                  <div
                    className="partener-three-img wow fadeInUp animated"
                    data-wow-duration="1500ms"
                    data-wow-delay="700ms"
                  >
                    <img
                      src={ClientImgOne7}
                      alt="client-one-img-7"
                    />
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">
                  <div
                    className="partener-three-img wow fadeInUp animated"
                    data-wow-duration="1500ms"
                    data-wow-delay="800ms"
                  >
                    <img
                      src={ClientImgOne8}
                      alt="client-one-img-8"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default PartnerThree
